import { useAtom } from "jotai";
import { useQueryClient } from "@tanstack/react-query";
import { workspaceIdAtom } from "../../../../atoms/WorkspaceAtoms";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";
import useWorkspacePermissions from "../../../../hooks/useWorkspacePermissions";
import StrUtils from "../../../../utils/StrUtils";
import WorkspaceAPI from "../../../api/WorkspaceAPI";

const useAddItem = () => {
  const queryClient = useQueryClient();
  const { wPermissions } = useWorkspacePermissions();
  const { cPermissions } = useCloudPermissions();
  const [workspaceID] = useAtom(workspaceIdAtom);

  const addItem = async (newItem: any) => {
    if (
      !wPermissions.workspace_modify_workspace &&
      !cPermissions.cloud_modify_workspace
    ) {
      return console.log("You do not have permission to modify this workspace");
    }

    const { workspace } = queryClient.getQueryData<any>([
      "workspace",
      workspaceID,
    ]);

    newItem.id = StrUtils.uuidv4();
    let newSidebar = [...workspace.Sidebar, newItem];

    newSidebar = newSidebar.filter((item) => item.Type !== "EmptySidebar");

    const data = await WorkspaceAPI.updateWorkspace(workspaceID, {
      Sidebar: newSidebar,
    });

    const newWorkspace = data.data.data.workspace;

    queryClient.setQueryData<any>(["workspace", workspaceID], (data: any) => ({
      ...data,
      workspace: newWorkspace,
    }));
  };

  return { addItem };
};

export default useAddItem;
